import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import PageList from "./page-list.jsx";

export default class ManagePages extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            title: '',
            yesLabel: '',
            noLabel: '',
            backLabel: '',
            pages: [],
            addNewPageLabel: ''
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onAddNewPage = this.onAddNewPage.bind(this);
        this.onBack = this.onBack.bind(this);
        this.setPages = this.setPages.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get("manage-pages")
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    yesLabel: res.data.yesLabel, 
                    noLabel: res.data.noLabel,
                    pages: res.data.pages,
                    backLabel: res.data.backLabel,
                    addNewPageLabel: res.data.addNewPageLabel
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onAddNewPage() {
        let self = this;
        window.location = context.root() + '/app/add-page/0';
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/marketing-admin';
    }

    setPages(data) {
        this.setState({
            pages: data
        });
    }

    render() {
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onAddNewPage} className="btn-info ap-fullsize" >{this.state.addNewPageLabel}</Button>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onBack} className="btn-info ap-fullsize">{this.state.backLabel}</Button>
                        </div>
                    </div>
                    <br />
                    <PageList onChange={this.setPages} pages={this.state.pages} noLabel={this.state.noLabel} yesLabel={this.state.yesLabel}></PageList>
                </div>
            </div>
        );
    }
}